import { render } from "./Main.vue?vue&type=template&id=c6de711c"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=c6de711c&lang=css"
script.render = render

export default script